import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    H3,
    LargePrimaryButton,
    LargeLinkButton,
    ModalPattern,
    Regular,
    RadioGroup,
    Radio,
    NumberInput,
} from "@worthy-npm/clarity";

import Popup from "components/popups/popup";
import { setNegotiationPrice, shipItemBack } from "actions/item";
import I18n from "lib/i18n/i18n";
import sendEvents from "lib/events";
import {
    disableBtn,
    dollarsWithoutCents,
    enableBtn,
    isMobile,
    imageUrl,
} from "helpers/ApplicationHelper";

const POPUP_OPTIONS = {
    HIGHER: "higher",
    OTHER_PRICE: "other",
};

class PopupAnotherChance extends Popup {
    static initPopup(props = {}) {
        Popup.initPopup.bind(this)(props);
    }
    constructor(props) {
        super(props);
        this.validatePrice = this.validatePrice.bind(this);
        this.sendToBuyers = this.sendToBuyers.bind(this);
        this.shipItemBack = this.shipItemBack.bind(this);
        this.pendingResponse = this.pendingResponse.bind(this);
        this.areYouSure = this.areYouSure.bind(this);
        this.sendNegotiationPrice = this.sendNegotiationPrice.bind(this);
        this.renderShipBackCta = this.renderShipBackCta.bind(this);
        this.renderCta = this.renderCta.bind(this);
        this.renderTextPart = this.renderTextPart.bind(this);
        this.renderNewPriceOptions = this.renderNewPriceOptions.bind(this);
        this.renderNewPriceField = this.renderNewPriceField.bind(this);
        this.getStylesForErrorMsg = this.getStylesForErrorMsg.bind(this);
        this.renderNotInterestedBtn = this.renderNotInterestedBtn.bind(this);

        this.state = {
            banner: props.banner,
            popupState: "warning",
            newPriceError: false,
            optionSelected: {
                type: null, // possible options POPUP_OPTIONS
                value: null, // will be saved price which user choose or type (number)
            },
            buy_it_now: props.buy_it_now,
            showNewPrice: "hidden",
        };
    }

    componentDidMount() {
        if (["lastChance", "lastChanceNewOffer"].includes(this.props.banner)) {
            let bannerName =
                this.props.banner === "lastChance"
                    ? "lastChanceNoBuyerFeesBid"
                    : this.props.banner;
            sendEvents.supportNegotiationEvent(
                this.props.item.id,
                `Seller viewed ship back popup - ${bannerName}`
            );
            this.areYouSure();
        } else {
            sendEvents.supportNegotiationEvent(
                this.props.item.id,
                "Seller viewed negotiation popup"
            );
        }
    }

    componentWillUnmount() {
        sendEvents.supportNegotiationEvent(
            this.props.item.id,
            `Seller closed popup - ${this.props.banner}`
        );
    }

    sendToBuyers(stopAnimation) {
        if (this.state.popupState === "warning") {
            new Promise(this.validatePrice(stopAnimation)).then(
                (validatedPrice) => {
                    this.sendNegotiationPrice(validatedPrice, stopAnimation);
                }
            );
        } else {
            sendEvents.supportNegotiationEvent(
                this.props.item.id,
                `Are you sure cancel clicked - ${this.props.banner}`
            );
            enableBtn(this.refs.mainbtn);
            if (
                ["lastChance", "lastChanceNewOffer"].includes(this.props.banner)
            ) {
                this._hide.bind(this)();
            } else {
                this.setState({
                    popupState: "warning",
                    showNewPrice: "hidden",
                    newPriceError: false,
                });
            }
        }
    }

    sendNegotiationPrice(validatedPrice, stopAnimation) {
        this.props
            .setNegotiationPrice(this.props.item.id, {
                price: validatedPrice,
            })
            .then((response) => {
                sendEvents.supportNegotiationEvent(
                    this.props.item.id,
                    "CHALLENGE BUYERS clicked",
                    this.state.optionSelected
                );
                stopAnimation();
                this.pendingResponse(response.payload.data.item);
            });
    }

    areYouSure() {
        this.setState({ popupState: "shipBack", showNewPrice: "hidden" });
    }

    pendingResponse(response) {
        this._hide.bind(this)();
        this.props.changeStateTo("pendingResponse", response.buy_it_now);
    }

    shipItemBack(notIntrestedBtn = false) {
        this.props
            .shipItemBack(this.props.item.id, {
                last_chance: ["lastChance", "lastChanceNewOffer"].includes(
                    this.props.banner
                ),
                press_not_intrested_btn: notIntrestedBtn,
            })
            .then(() => {
                this.props.changeStateTo("shipBack");
                this._hide.bind(this)();
            });
    }

    validatePrice(stopAnimation) {
        return (resolve, reject) => {
            const { optionSelected } = this.state;
            const { item } = this.props;

            if (!optionSelected.type) {
                // handle case when user choose suggested option
                this.setState({ newPriceError: "select" });
                stopAnimation();

                return reject();
            }

            const valueToSend = parseFloat(optionSelected.value);
            const min = parseFloat(item.highest_bid_after_buyer_fees);
            const max = parseFloat(item.minimum_price);

            if (isNaN(valueToSend) || valueToSend < min || valueToSend > max) {
                if (optionSelected.type === POPUP_OPTIONS.OTHER_PRICE) {
                    const typeError =
                        valueToSend < min
                            ? "must_be_higher"
                            : valueToSend >= max
                            ? "must_be_lower"
                            : "empty";
                    this.setState({ newPriceError: typeError });
                }

                stopAnimation();
                sendEvents.supportNegotiationEvent(
                    this.props.item.id,
                    "New price value error"
                );
                return reject();
            } else {
                return resolve(valueToSend);
            }
        };
    }

    renderShipBackCta() {
        return (
            <button
                className="btn cta2"
                ref="whitebtn"
                onClick={() => {
                    disableBtn(this.refs.whitebtn);
                    let bannerName =
                        this.props.banner === "lastChance"
                            ? "lastChanceNoBuyerFeesBid"
                            : this.props.banner;
                    sendEvents.supportNegotiationEvent(
                        this.props.item.id,
                        `Seller clicked ship back - ${bannerName}`
                    );
                    this.shipItemBack();
                }}
            >
                {I18n.getString(
                    `itemPage::popupAnotherChance::${this.state.popupState}::cta2`
                )}
            </button>
        );
    }

    getStylesForErrorMsg(errorType) {
        return {
            color: "red",
            fontSize: "16px",
            margin: `${isMobile() ? "-16px" : "-24px"} 0 -4px 15px`,
            display:
                this.state.newPriceError &&
                this.state.newPriceError === errorType
                    ? "block"
                    : "none",
        };
    }

    renderNewPriceField() {
        const hideFieldStyle = {
            visibility:
                this.state.showNewPrice === "hidden" ? "hidden" : "visible",
        };

        return (
            <div id="new-price-input" style={hideFieldStyle}>
                <div
                    style={{
                        position: "relative",
                        paddingLeft: "40px",
                        width: "78%",
                        marginBottom: "15px",
                        marginTop: "-10px",
                        height: "100px",
                    }}
                >
                    <NumberInput
                        change={(value, e) =>
                            this.setState({
                                optionSelected: {
                                    ...this.state.optionSelected,
                                    value,
                                },
                            })
                        }
                        focus={() => {
                            sendEvents.supportNegotiationEvent(
                                this.props.item.id,
                                "New price focus"
                            );
                        }}
                        blur={(value) => {
                            sendEvents.supportNegotiationEvent(
                                this.props.item.id,
                                "New price entered",
                                value
                            );
                        }}
                    />
                    <div style={this.getStylesForErrorMsg("must_be_lower")}>
                        {I18n.getString(
                            `itemPage::popupAnotherChance::${this.state.popupState}::priceLower`
                        )}{" "}
                        {dollarsWithoutCents(this.props.item.minimum_price)}
                    </div>
                    <div style={this.getStylesForErrorMsg("must_be_higher")}>
                        {I18n.getString(
                            `itemPage::popupAnotherChance::${this.state.popupState}::priceHigher`
                        )}{" "}
                        {dollarsWithoutCents(
                            this.props.item.highest_bid_after_buyer_fees
                        )}
                    </div>
                    <div style={this.getStylesForErrorMsg("empty")}>
                        {I18n.getString(
                            `itemPage::popupAnotherChance::${this.state.popupState}::noPrice`
                        )}
                    </div>
                </div>
            </div>
        );
    }

    renderNewPriceOptions() {
        const { optionSelected } = this.state;
        const averageIncrement = this.props.item.increments[1];

        /* Need to use inline styles in order to use it on mobile and desktop */
        const higherOption = `
            <span class='option1'>
                    <span style='font-weight: bold'>${dollarsWithoutCents(
                        averageIncrement
                    )}</span>
                    <span style='background-image: url(${imageUrl(
                        "common/greenArrowUp.svg"
                    )}); background-repeat: no-repeat; display: inline-block; width: 16px; height: 12px; margin-left: 5px'></span>
                    <span style='color: #128801; margin-left: -4px'>
                        ${
                            this.props.item
                                .support_negotiation_increment_default_percent[1]
                        }%
                        <span style="color: #128801">${I18n.getString(
                            "itemPage::popupAnotherChance::warning::higher"
                        )}</span>
                    </span>
            </span>
        `;

        return (
            <div
                className="negotiation-price-options"
                style={{ marginTop: "32px" }}
            >
                <div
                    style={{
                        ...this.getStylesForErrorMsg("select"),
                        marginLeft: "10px",
                    }}
                >
                    {I18n.getString(
                        `itemPage::popupAnotherChance::${this.state.popupState}::selectOption`
                    )}
                </div>
                <RadioGroup
                    onChange={(value) =>
                        this.setState({
                            optionSelected: {
                                type: value,
                                value:
                                    value === POPUP_OPTIONS.HIGHER
                                        ? averageIncrement
                                        : null,
                            },
                            newPriceError:
                                this.state.newPriceError === "select"
                                    ? ""
                                    : this.state.newPriceError,
                            showNewPrice:
                                value === POPUP_OPTIONS.OTHER_PRICE
                                    ? ""
                                    : "hidden",
                        })
                    }
                    value={optionSelected}
                >
                    <span>
                        <Radio
                            label={higherOption}
                            value={POPUP_OPTIONS.HIGHER}
                        />
                        <span
                            style={{
                                // the same motivation as for higherOption using inline style in order to use it on mobile and desktop
                                display: "block",
                                color: "#bdbdbd",
                                marginLeft: "40px",
                                marginTop: "-10px",
                                transform: isMobile()
                                    ? "translateY(-10px)"
                                    : "translateY(-25px)",
                            }}
                        >
                            {I18n.getString(
                                "itemPage::popupAnotherChance::warning::secondOption"
                            )}
                        </span>
                    </span>
                    <Radio
                        label={I18n.getString(
                            `itemPage::popupAnotherChance::warning::subtitle`
                        )}
                        value={POPUP_OPTIONS.OTHER_PRICE}
                    />
                </RadioGroup>
            </div>
        );
    }

    renderTextPart(withHeader = false) {
        return (
            <>
                {withHeader && (
                    <H3
                        text={I18n.getString(
                            `itemPage::popupAnotherChance::${this.state.popupState}::title`
                        )}
                    />
                )}
                <Regular
                    text={I18n.getJsx(
                        `itemPage::popupAnotherChance::${this.state.popupState}::text`,
                        {
                            highestBid: (
                                <span className="bold">
                                    {dollarsWithoutCents(
                                        this.props.item
                                            .highest_bid_after_buyer_fees
                                    )}
                                </span>
                            ),
                        }
                    )}
                />
            </>
        );
    }

    renderCta() {
        return this.state.popupState === "warning" ? (
            <div className="ctaBtnWrapper" style={{ textAlign: "center" }}>
                {/* NOT A GOOD SOLUTION BUT DONT HAVE ANY OTHER OPTION TO SAVE TEXT_TRANSFORM property to be capitalize */}
                <style
                    dangerouslySetInnerHTML={{
                        __html: `
                  button { text-transform: capitalize }
                `,
                    }}
                />
                <LargePrimaryButton
                    text={I18n.getString(
                        `itemPage::popupAnotherChance::${this.state.popupState}::cta`
                    )}
                    click={(stopAnimation) => this.sendToBuyers(stopAnimation)}
                />
            </div>
        ) : (
            // keep old view for ship back modal
            <div>
                <button
                    className="btn btn-orange"
                    ref="mainbtn"
                    onClick={() => {
                        disableBtn(this.refs.mainbtn);
                        this.sendToBuyers();
                    }}
                >
                    {I18n.getString(
                        `itemPage::popupAnotherChance::${this.state.popupState}::cta`
                    )}
                </button>
            </div>
        );
    }

    renderNotInterestedBtn() {
        return (
            <div
                style={{
                    width: "100%",
                    textAlign: "center",
                    marginTop: "15px",
                }}
            >
                <LargeLinkButton
                    text={I18n.getString(
                        `itemPage::popupAnotherChance::warning::notInterestedBtn`
                    )}
                    click={() => this.shipItemBack(true)}
                />
            </div>
        );
    }

    content() {
        return (
            <div className={this.state.popupState}>
                {this.renderTextPart(true)}
                {this.state.popupState === "warning" &&
                    this.renderNewPriceOptions()}
                {this.renderNewPriceField()}
                {this.renderShipBackCta()}
                {this.renderCta()}
                {this.state.popupState === "warning" &&
                    this.renderNotInterestedBtn()}
            </div>
        );
    }

    render() {
        /*
         *  This view will be rendered only for auction_ended modal on mobile for shipBack will be used old one
         * */
        const renderMobileVersion = () => (
            <ModalPattern
                textAlign={"left"}
                title={I18n.getString(
                    `itemPage::popupAnotherChance::${this.state.popupState}::title`
                )}
                closeIcon={true}
                closeOnClickOutside={false}
                closeOnEscape={false}
            >
                {this.renderTextPart()}
                {this.renderNewPriceOptions()}
                {this.renderNewPriceField()}
                {this.renderCta()}
                {this.state.popupState === "warning" &&
                    this.renderNotInterestedBtn()}
            </ModalPattern>
        );

        return isMobile() && this.props.banner === "auction_ended"
            ? renderMobileVersion()
            : super.render(); // for desktop user paren render which will call content method.
    }
}

PopupAnotherChance.defaultProps = {
    popupClassName:
        "popup-tooltip popup-tooltip-another-chance popup-compact popups-another-change",
    single: true,
    modal: true,
    classNames: ["no-animation"],
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ setNegotiationPrice, shipItemBack }, dispatch);
};
export default connect(null, mapDispatchToProps)(PopupAnotherChance);
